import {ifNotAuthenticated} from "@/router";

export default [
    {
        path: "/login",
        name: "login",
        beforeEnter: ifNotAuthenticated,
        component: () => import(/* webpackChunkName: "auth" */ "@/views/auth/Login.vue"),
    },
    {
        path: "/register/:token",
        name: "register",
        beforeEnter: ifNotAuthenticated,
        component: () => import(/* webpackChunkName: "auth" */ "@/views/auth/Register.vue"),
    },
    {
        path: "/reset-password/:token",
        name: "resetPassword",
        beforeEnter: ifNotAuthenticated,
        component: () => import(/* webpackChunkName: "auth" */ "@/views/auth/ResetPassword.vue"),
    },
];